/**
 * Patient Surveys entry point. Minimal app that renders a survey form
 * from a signed token URL.
 * @agentic members
 */

import "@mantine/core/styles.css";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { App } from "./App";
import { surveyTheme } from "./surveyTheme";

const container = document.getElementById("root") as HTMLDivElement;
const root = createRoot(container);
root.render(
  <StrictMode>
    <MantineProvider theme={surveyTheme} defaultColorScheme="light">
      <App />
    </MantineProvider>
  </StrictMode>,
);
